import ActionConstants from '../constants/ActionConstants';

const initialState = {
  title: '',
  crumbs: [],
  showBack: false,
  titleInfo: null,
};

const pageHeader = (state = initialState, action) => {
  switch (action.type) {
    case ActionConstants.SET_PAGE_HEADER:
      return {
        title: action.payload.title || '',
        crumbs: action.payload.crumbs || [],
        showBack: Boolean(action.payload.showBack),
        titleInfo: action.payload.titleInfo || null,
      };
    case ActionConstants.CLEAR_PAGE_HEADER:
      return { ...initialState };
    default:
      return state;
  }
};

export default pageHeader;
